import { ISlackMessageField } from './slack-message-field.interface';

export interface ISlackMessage {
  title: string;
  pretext?: string;
  text?: string;
  color?: 'good' | 'warning' | 'danger' | string;
  author_name?: string;
  author_link?: string;
  image_url?: string;
  channel?: string;
  fields?: ISlackMessageField[];
}
